export default "__VITE_ASSET__BEx$A9FD__"